import { render } from "./FeesTable.vue?vue&type=template&id=c3f0ca5e&scoped=true&ts=true"
import script from "./FeesTable.vue?vue&type=script&lang=ts"
export * from "./FeesTable.vue?vue&type=script&lang=ts"

import "./FeesTable.vue?vue&type=style&index=0&id=c3f0ca5e&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f0ca5e"]])

export default __exports__